var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVerySatisfied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6,
    cy: 12,
    r: 9,
    fill: "#FFD74B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 11C16.928 11 17.6 10.328 17.6 9.5C17.6 8.672 16.928 8 16.1 8C15.272 8 14.6 8.672 14.6 9.5C14.6 10.328 15.272 11 16.1 11Z",
    fill: "#1A1B43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10001 11C9.92801 11 10.6 10.328 10.6 9.5C10.6 8.672 9.92801 8 9.10001 8C8.27201 8 7.60001 8.672 7.60001 9.5C7.60001 10.328 8.27201 11 9.10001 11Z",
    fill: "#1A1B43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 18C10.263 18 8.19601 16.686 7.33501 14.652C7.12001 14.143 7.35701 13.557 7.86601 13.341C8.37301 13.126 8.96101 13.364 9.17701 13.872C9.71601 15.144 11.091 15.999 12.6 15.999C14.109 15.999 15.484 15.144 16.022 13.872C16.237 13.364 16.824 13.125 17.333 13.341C17.842 13.556 18.08 14.143 17.864 14.652C17.003 16.686 14.937 18 12.6 18Z",
    fill: "#1A1B43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.59 2C7.07001 2 2.60001 6.48 2.60001 12C2.60001 17.52 7.07001 22 12.59 22C18.11 22 22.6 17.52 22.6 12C22.6 6.48 18.12 2 12.59 2ZM12.6 20C8.18001 20 4.60001 16.42 4.60001 12C4.60001 7.58 8.18001 4 12.6 4C17.02 4 20.6 7.58 20.6 12C20.6 16.42 17.02 20 12.6 20Z",
    fill: "#1A1B43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerySatisfied);
export default __webpack_public_path__ + "static/media/icon-very-satisfied.3781f675d2947ed729c3762cdd822399.svg";
export { ForwardRef as ReactComponent };